import React from 'react';

type IconProps = React.SVGProps<SVGSVGElement>;

const PhoneIcon: React.FC<IconProps> = (props) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.0101 12.38C15.7801 12.38 14.5901 12.18 13.4801 11.82C13.3061 11.7614 13.1192 11.7528 12.9407 11.7953C12.7621 11.8377 12.599 11.9294 12.4701 12.06L10.9001 14.03C8.07006 12.68 5.42006 10.13 4.01006 7.2L5.96006 5.54C6.23006 5.26 6.31006 4.87 6.20006 4.52C5.83006 3.41 5.64006 2.22 5.64006 0.99C5.64006 0.45 5.19006 0 4.65006 0H1.19006C0.650061 0 6.10352e-05 0.24 6.10352e-05 0.99C6.10352e-05 10.28 7.73006 18 17.0101 18C17.7201 18 18.0001 17.37 18.0001 16.82V13.37C18.0001 12.83 17.5501 12.38 17.0101 12.38Z" fill="#A0AEC0"/>
</svg>


);

export default PhoneIcon;


